import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Checkout } from '../../types/checkout';

export interface CheckoutItem {
  data: Checkout;
  updatedAt: number;
  _persistedAt?: number;
}

export interface CheckoutState {
  byId: Record<string, CheckoutItem>;
}

export const initialCheckoutState: CheckoutState = { byId: {} };

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: initialCheckoutState,
  reducers: {
    upsertCheckout(state, action: PayloadAction<Checkout>) {
      const c = action.payload;
      state.byId[c.produtoId] = {
        data: c,
        updatedAt: Date.now(),
      };
    },
    removeCheckout(state, action: PayloadAction<string>) {
      delete state.byId[action.payload];
    },
    clearAllCheckouts() {
      return initialCheckoutState;
    },
  },
});

export const { upsertCheckout, removeCheckout, clearAllCheckouts } =
  checkoutSlice.actions;
export default checkoutSlice.reducer;
